import React from 'react';
import ActionButton from '../../../../elements/ActionButton/ActionButton';
import { bestTextColor } from '../../../../../misc/colorUtils';

export default function EventExhibitorsButton({ event }) {
    if (!event?.settings?.exhibitors_label) {
        return null;
    }

    const bgColor = event.settings.secondary_color;
    const textColor = bgColor ? bestTextColor(bgColor, event.settings.primary_color) : undefined;

    return (
        <ActionButton secondary next small href={event.id + '/exhibitors'}
            color={bgColor}
            style={{ color: textColor }}
            nextColor={textColor}>
            {event.settings.exhibitors_label}
        </ActionButton>
    );
}
